import { render, staticRenderFns } from "./PMCForm.vue?vue&type=template&id=f620911a&scoped=true"
import script from "./PMCForm.vue?vue&type=script&lang=js"
export * from "./PMCForm.vue?vue&type=script&lang=js"
import style0 from "./PMCForm.vue?vue&type=style&index=0&id=f620911a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f620911a",
  null
  
)

export default component.exports